require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./curry-county-thinking-for-a-change.json") })
        }
      }, "path---curry-county-thinking-for-a-change");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---curry-county-thinking-for-a-change!./.cache/json/curry-county-thinking-for-a-change.json
// module id = 870
// module chunks = 231608221292675